
import './App.css';
import {Routes,Route} from 'react-router-dom'
import {Login} from './components/index';
import Home from './container/Home';
function App() {

  return (
    
    <Routes>
      <Route exact path='/login' element={<Login/>} /> :
      <Route  exact path='/*' element={<Home/>} />
    </Routes>
  );
}

export default App;
